export default __webpack_public_path__ + "static/media/phone.653e31d4.svg";